import React from 'react';
import { Trans } from '@lingui/macro';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useFooterStyles = makeStyles((theme: Theme) =>
    createStyles({
        siteFooter: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            zIndex: 1000,
            width: '100%',
            padding: '4px 4px',
            fontSize: '0.875rem',
            color: '#6b7280',
            borderTop: '1px solid #d1d5db',
            backgroundColor: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '15px',
        },
        footerLink: {
            color: '#6b7280',
            textDecoration: 'none',
            transition: 'color 0.15s ease-in',
            '&:hover': {
                color: '#4a5568',
            },
        },
    })
);

const Footer: React.FC = () => {
    const classes = useFooterStyles();

    return (
        <footer className={classes.siteFooter}>
            <a href="/cookie-settings" className={classes.footerLink}>
                <Trans>Cookie Settings</Trans>
            </a>
            <a
                href="https://www.hwmglobal.com/privacy/"
                className={classes.footerLink}
                target="_blank"
                rel="noopener noreferrer"
            >
                <Trans>Privacy Policy</Trans>
            </a>
        </footer>
    );
};

export default Footer;
